var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex justify-start gap-2 my-2"},[_c('vs-button',{attrs:{"color":"primary","type":"filled","size":"medium"},on:{"click":_vm.clickCreate}},[_vm._v(" Create ")]),_c('vs-button',{attrs:{"color":"warning","type":"filled","size":"medium"},on:{"click":_vm.clickUpload}},[_vm._v(" Upload ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }